import { render, staticRenderFns } from "./LinkAction.vue?vue&type=template&id=303a65b0&scoped=true"
import script from "./LinkAction.vue?vue&type=script&lang=js"
export * from "./LinkAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a65b0",
  null
  
)

export default component.exports